export const getNormalizeText = text => {
  if (!text) return '';

  return text
    .replace(/\r\n|\r|\n/g, '<br /> ') // \n → <br />
    .replace(/<br\s*\/?>/gi, '<br /> '); // уніфікуємо всі <br>
};
